import api from "app/api";
import { Options } from "common";

export interface CouponItem {
  id: number;
  code: string;
  discount_percent: number;
  partner_id: number;
  active: boolean;
}

export type CouponOptions = Options<never>;

export function getCouponService(scope?: any) {
  return api.getService<CouponItem, CouponItem, CouponOptions>("coupons", {
    scope,
  });
}
